import Vue from "@/main";
import * as kgUtil from "../../../../public/lib/kml/kml-geojson.js";
import DataWorker from "@/mapUtils/Multithreading";
import * as indexedDbMap from "@/components/tables/indexedDb/map.js";
/**
 * KML数据
 */
export let graphicLayer = [];
export let underground = null;
// 线上大体量kml数据
export let bigKmlData = [398916547604549];
let loadData = [];
let worker = null;

/**
 * 工具类
 * 简化geojson的坐标
 * @returns { any }
 */
export function notSimplifyKmlGeoJSON(geojson) {
  //do nothing
  return geojson;
}
export function lowSimplifyKmlGeoJSON(geojson) {
  try {
    geojson = turf.simplify(geojson, {
      tolerance: 0.005,
      highQuality: false,
      mutate: true,
    });
  } catch (e) {}
  return geojson;
}
export function mediumSimplifyKmlGeoJSON(geojson) {
  try {
    geojson = turf.simplify(geojson, {
      tolerance: 0.0005,
      highQuality: false,
      mutate: true,
    });
  } catch (e) {}
  return geojson;
}
export function highSimplifyKmlGeoJSON(geojson) {
  try {
    geojson = turf.simplify(geojson, {
      tolerance: 0.00005,
      highQuality: false,
      mutate: true,
    });
  } catch (e) {}
  return geojson;
}

export function removeLayer() {
  Vue.$GLOBAL.map.trackedEntity = null;
  if (graphicLayer) {
    graphicLayer.forEach((e) => {
      if (
        e._state != "destroy" &&
        e.uuid &&
        Vue.$GLOBAL.map.getLayerById(e.uuid) != undefined
      ) {
        Vue.$GLOBAL.map.removeLayer(e.uuid);
      }
    });
    graphicLayer = [];
    loadData = [];
  }
}

export function addKmlLayer(array) {
  removeLayer();
  Vue.$NProgress.configure({
    easing: "ease",
    showSpinner: true,
  });
  Vue.$NProgress.set(0.8).inc(0.2);
  array.forEach((e) => {
    let simplifyFunc = notSimplifyKmlGeoJSON;
    if (
      item.kmlInfo?.isOptimization !== undefined &&
      !item.kmlInfo?.isOptimization
    ) {
      simplifyFunc = notSimplifyKmlGeoJSON;
    } else {
      switch (item.kmlInfo?.optimizationDegree) {
        case "low":
          simplifyFunc = lowSimplifyKmlGeoJSON;
          break;
        case "medium":
          simplifyFunc = mediumSimplifyKmlGeoJSON;
          break;
        case "high":
          simplifyFunc = highSimplifyKmlGeoJSON;
          break;
        default:
          simplifyFunc = notSimplifyKmlGeoJSON;
          break;
      }
    }
    Vue.$GLOBAL.labelListTree.find((item) => {
      if (item.id == e) {
        let kmlLayer = new mars3d.layer.Kml2JsonLayer({
          //url: "/baseIP/" + item.kmlInfo.kmlUrl,
          url: Vue.$GLOBAL.localResourcesPath + item.kmlInfo.kmlUrl,
          format: simplifyFunc,
          symbol: function (attr, style, featue) {
            return {
              fill: item.kmlInfo.fill,
              color: item.kmlInfo.textColor,
              opacity: 0.5,
              outline: true,
              outlineColor: item.kmlInfo.textColor,
              outlineWidth: 3,
              width: 3,
              // arcType: Cesium.ArcType.GEODESIC,
              // 标记文字
              clampToGround: true,
              //visibleDepth: false,
              distanceDisplayCondition: true,
              distanceDisplayCondition_far: item.kmlInfo.textDistinct || 20000,
              distanceDisplayCondition_near: 0,
              label: {
                text: "{name}",
                //text: item.kmlInfo.kmlName,//不应该这样写，因此让程序自己去解析文件里的name。
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                pixelOffsetY: -10,
                opacity: 1,
                font_size: item.kmlInfo.textSize || 26,
                color: item.kmlInfo.textColor || "#ffffff",
                font_family: "黑体",
                outline: true,
                outlineColor: item.kmlInfo.sideColor || "#000000",
                outlineWidth: 3,
                scaleByDistance: true,
                scaleByDistance_far: 10000,
                scaleByDistance_farValue: 0.1,
                scaleByDistance_near: 20,
                scaleByDistance_nearValue: 1,
                distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
                  0.0,
                  item.kmlInfo.textDistinct || 20000
                ),
                clampToGround: true, //不贴地
                // visibleDepth: false,
              },

              // polygon: {
              //   distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
              //     0.0,
              //     item.kmlInfo.textDistinct || 20000
              //   ),
              //   visibleDepth: false,
              //   clampToGround: false, //不贴地
              // },
            };
          },
          // center: { lat: 31.653222, lng: 117.273592, alt: 35183, heading: 358, pitch: -63 },
          popup: "all",
          // flyTo: true,
          clampToGround: true, //是否贴地
          // visibleDepth: false, //避免文字被遮挡
          // show: false,
          // // "tooltip": "{name}",
          hasZIndex: true, //是否可以调整图层顺序（在同类型图层间）
          zIndex: item.kmlInfo.order, //图层顺序，数字大的在上面。（当hasZIndex为true时）
        });
        Vue.$GLOBAL.map.addLayer(kmlLayer);
        graphicLayer.push(kmlLayer);
        kmlLayer.on(mars3d.EventType.load, function (event) {
          loadData.push(event.layer.uuid);
          if (loadData.length == graphicLayer.length) {
            // 数据加载完成
            Vue.$NProgress.done(true);
            // showKmlLayer();
          }
        });
      }
    });
  });
}

export function showKmlLayerId(property, id, fn, ...list) {
  let map = Vue.$GLOBAL.map,
    currentKML,
    ifGraphicLayer,
    terrain = {},
    visibleDepth = {},
    mapType;
  if (list.length > 0 && list[0] != undefined) {
    mapType = list[0].mapType;

    if (mapType == "clone") {
      map = Vue.$GLOBAL.mapClone;
    }
  }

  if (Vue.$route.params.stype.indexOf("sandbox") >= 0) {
    if (window.sessionStorage.getItem("nowProjectId") == "255513056948293") {
      terrain = {
        classificationType: Cesium.ClassificationType.TERRAIN,
        disableDepthTestDistance: 2000,
      };
    } else {
      terrain = {
        disableDepthTestDistance: 2000,
      };
    }
    visibleDepth = {
      classificationType: Cesium.ClassificationType.TERRAIN,
      disableDepthTestDistance: 2000,
    };
  } else {
    visibleDepth = {
      visibleDepth: false,
    };
  }

  if ((typeof property == "boolean" && property) || property == "true") {
    Vue.$NProgress.configure({
      easing: "ease",
      showSpinner: true,
    });
    Vue.$NProgress.set(0.8).inc(0.2);
    if (map.getLayer(id, "Kmlid") && mapType != "clone") {
      // 把销毁改成隐藏
      map.getLayer(id, "Kmlid").show = true;
      // getSimpleTerrainHeight();
      Vue.$NProgress.done(true);
      return;
    }
    currentKML = Vue.$GLOBAL.labelListTree.find((item) => item.id == id);
    if (currentKML) {
      let simplifyFunc = notSimplifyKmlGeoJSON;
      if (
        currentKML.kmlInfo?.isOptimization !== undefined &&
        !currentKML.kmlInfo?.isOptimization
      ) {
        simplifyFunc = notSimplifyKmlGeoJSON;
      } else {
        switch (currentKML.kmlInfo?.optimizationDegree) {
          case "low":
            simplifyFunc = lowSimplifyKmlGeoJSON;
            break;
          case "medium":
            simplifyFunc = mediumSimplifyKmlGeoJSON;
            break;
          case "high":
            simplifyFunc = highSimplifyKmlGeoJSON;
            break;
          default:
            simplifyFunc = notSimplifyKmlGeoJSON;
            break;
        }
      }

      if (bigKmlData.indexOf(id) != -1) {
        indexedDbMap.readUniqueIndex(
          "kmlDb",
          "id",
          currentKML.id,
          (status, data) => {
            if (data && data.content.length > 0) {
              let kmlLayer = new mars3d.layer.Kml2JsonLayer({
                url: Vue.$GLOBAL.localResourcesPath + currentKML.kmlInfo.kmlUrl,
                format: simplifyFunc,
                Kmlid: currentKML.id,
                symbol: (attr, style, featue) => {
                  return {
                    image: data.content.find((e) => e.POI_ID == attr.POI_ID)
                      .image,
                    opacity: String(currentKML.kmlInfo.transparency) || 0.5,
                    outline: currentKML.kmlInfo.isAreaSideColor,
                    outlineColor: currentKML.kmlInfo.areaSideColor,
                    outlineWidth: 3,
                    scale: 0.5,
                    ...visibleDepth,
                    distanceDisplayCondition: true,
                    distanceDisplayCondition_far:
                      currentKML.kmlInfo.textDistinct || 1000000,
                    distanceDisplayCondition_near: 0,
                    clampToGround: true,
                    disableDepthTestDistance: 3000,
                  };
                },
                popup: `&nbsp;&nbsp; ${currentKML.title} &nbsp;&nbsp;`,
                hasZIndex: true, //是否可以调整图层顺序（在同类型图层间）
                zIndex: currentKML.kmlInfo.order, //图层顺序，数字大的在上面。（当hasZIndex为true时）
              });
              map.addLayer(kmlLayer);
              graphicLayer = graphicLayer.filter((currentKML) => {
                return currentKML._state != "destroy";
              });
              ifGraphicLayer = graphicLayer.find((x) => {
                return x.options?.Kmlid == currentKML.id;
              });

              if (ifGraphicLayer == undefined) graphicLayer.push(kmlLayer);

              kmlLayer.on(mars3d.EventType.load, function (event) {
                loadData.push(event.layer.uuid);
                Vue.$NProgress.done(true);
                // 回调，kml加载完成
                if (fn) {
                  fn(Promise.resolve(true));
                }
              });
            } else {
              Vue.$NProgress.done(true);
              Vue.$notify({
                title: `请先缓存数据，再重新勾选`,
                message: "",
                type: "warning",
                duration: 960,
                offset: 320,
              });
            }
          }
        );
      } else {
        if (currentKML.kmlInfo.materialType == "Water") {
          let waters = new mars3d.layer.Kml2JsonLayer({
            url: Vue.$GLOBAL.localResourcesPath + currentKML.kmlInfo.kmlUrl,
            Kmlid: currentKML.id,
            symbol: function (attr, style, featue) {
              return {
                type: "waterC",
                height: 16, // 水面高度
                normalMap: "/images/waterNormals.jpg", // 水正常扰动的法线图
                frequency: 8000.0, // 控制波数的数字。
                animationSpeed: 0.02, // 控制水的动画速度的数字。
                amplitude: 5.0, // 控制水波振幅的数字。
                specularIntensity: 0.8, // 控制镜面反射强度的数字。
                baseWaterColor: "#006ab4", // rgba颜色对象基础颜色的水。#00ffff,#00baff,#006ab4
                blendColor: "#006ab4", // 从水中混合到非水域时使用的rgba颜色对象。
                opacity: 0.4, // 透明度
                clampToGround: true, // 是否贴地
                label: {
                  text: "{name}",
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  pixelOffsetY: -10,
                  opacity: 0.5,
                  font_size: currentKML.kmlInfo.textSize || 26,
                  color: currentKML.kmlInfo.textColor || "#ffffff",
                  font_family: currentKML.kmlInfo.fontStyle || "黑体",
                  outline: currentKML.kmlInfo.outLine || true,
                  outlineColor: currentKML.kmlInfo.sideColor || "#000000",
                  outlineWidth: 4,
                  scaleByDistance: true,
                  scaleByDistance_far: 10000,
                  scaleByDistance_near: 20,
                  scaleByDistance_nearValue: 1,
                  distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
                    0,
                    currentKML.kmlInfo.textDistinct || 1000000
                  ),
                  background: currentKML.kmlInfo.backGround || false,
                  backgroundColor: currentKML.kmlInfo.backGroundColor || "",
                  disableDepthTestDistance: 2000,
                  visibleDepth,
                  clampToGround: currentKML.clampToGround || false,
                },
              };
            },
          });
          map.addLayer(waters);

          waters.on(mars3d.EventType.load, function (e) {
            loadData.push(e.layer.uuid);
            Vue.$NProgress.done(true);
            graphicLayer = graphicLayer.filter((currentKML) => {
              return currentKML._state != "destroy";
            });

            ifGraphicLayer = graphicLayer.find((x) => {
              return x.options?.Kmlid == currentKML.id;
            });
            if (ifGraphicLayer == undefined) graphicLayer.push(e.layer);
            e.layer.bindPopup(
              function (event) {
                const attr = event.graphic.attr;
                let description;
                if (
                  /<[a-z]+\d?(\s+[\w-]+=("[^"]*"|'[^']*'))*\s*\/?>|&#?\w+;/i.test(
                    attr.description
                  )
                ) {
                  description = `<p> ${currentKML.title} </p>  ${attr.description}`;
                } else {
                  description = `&nbsp;&nbsp; ${currentKML.title} &nbsp;&nbsp;`;
                }
                return description;
              },
              { timeRender: true, closeButton: false } // timeRender实时刷新
            );
            if (fn) {
              fn(Promise.resolve(true));
            }
          });
        } else {
          bimVector
            .add({
              url: Vue.$GLOBAL.localResourcesPath + currentKML.kmlInfo.kmlUrl,
              id: currentKML.id,
              format: simplifyFunc,
              fill: currentKML.kmlInfo.fill,
              color: currentKML.kmlInfo.areaColor,
              opacity: String(currentKML.kmlInfo.transparency),
              outline: currentKML.kmlInfo.isAreaSideColor,
              outlineColor: currentKML.kmlInfo.areaSideColor,
              clampToGround: currentKML.kmlInfo.clampToGround,
              ...visibleDepth,
              distanceDisplayCondition_far: currentKML.kmlInfo.textDistinct,
              title: currentKML.title,
              zIndex: currentKML.kmlInfo.order,
              itemMap: map,
            })({
              font_size: currentKML.kmlInfo.textSize,
              color: currentKML.kmlInfo.textColor,
              font_family: currentKML.kmlInfo.fontStyle,
              outline: currentKML.kmlInfo.outLine,
              outlineColor: currentKML.kmlInfo.sideColor,
              distanceDisplayCondition_near: 0,
              distanceDisplayCondition_far: currentKML.kmlInfo.textDistinct,
              ...visibleDepth,
              background: currentKML.kmlInfo.backGround,
              backgroundColor: currentKML.kmlInfo.backGroundColor,
            })
            .then((e) => {
              loadData.push(e.layer.uuid);
              Vue.$NProgress.done(true);
              graphicLayer = graphicLayer.filter((currentKML) => {
                return currentKML._state != "destroy";
              });

              ifGraphicLayer = graphicLayer.find((x) => {
                return x.options?.Kmlid == currentKML.id;
              });
              if (ifGraphicLayer == undefined) graphicLayer.push(e.layer);
              e.layer.bindPopup(
                function (event) {
                  const attr = event.graphic.attr;
                  let description;
                  if (
                    /<[a-z]+\d?(\s+[\w-]+=("[^"]*"|'[^']*'))*\s*\/?>|&#?\w+;/i.test(
                      attr.description
                    )
                  ) {
                    description = `<p> ${currentKML.title} </p>  ${attr.description}`;
                  } else {
                    description = `&nbsp;&nbsp; ${currentKML.title} &nbsp;&nbsp;`;
                  }
                  return description;
                },
                { timeRender: true, closeButton: false } // timeRender实时刷新
              );
              if (fn) {
                fn(Promise.resolve(true));
              }
            });
        }
      }
    } else {
      Vue.$NProgress.done(true);
    }
  } else {
    graphicLayer.reverse().find((item, index) => {
      if (
        item.options &&
        item.options.Kmlid == id &&
        map.getLayer(id, "Kmlid")
      ) {
        map.removeLayer(item, true);
        // 把销毁改成隐藏
        // item.show = false;
        // graphicLayer.splice(index, 1);
      }
    });
  }
}
/**
 * 给kml添加缓存
 */
export function simplifyKmlData(url, id) {
  console.log(url, id);
  Vue.$NProgress.configure({
    easing: "ease",
    showSpinner: true,
  });
  Vue.$NProgress.set(0.8).inc(0.2);
  let warningNotify = Vue.$notify({
    title: `缓存数据中....`,
    message: "",
    type: "warning",
    duration: 960,
    offset: 320,
    duration: 0,
  });
  indexedDbMap.readUniqueIndex("kmlDb", "id", id, (status, data) => {
    if (data == undefined) {
      console.log("添加数据库");
      getKmlData(url, id)
        .then((response) => {
          indexedDbMap.add("kmlDb", response, (status) => {
            if (status == 0) {
              Vue.$NProgress.done(true);
              warningNotify.close();
              Vue.$notify({
                title: `缓存完成`,
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              console.log("add kml indexedDb success");
            } else {
              Vue.$NProgress.done(true);
              warningNotify.close();
              Vue.$notify({
                title: `缓存失败`,
                message: "",
                type: "error",
                duration: 960,
                offset: 320,
              });
              console.log("add kml indexedDb fail");
            }
            worker.close();
          });
        })
        .catch((e) => {
          console.error(e);
          worker.close();
        });
    } else {
      console.log("更新数据库");
      getKmlData(url, id)
        .then((response) => {
          indexedDbMap.update("kmlDb", response, (status) => {
            if (status == 0) {
              Vue.$NProgress.done(true);
              warningNotify.close();
              Vue.$notify({
                title: `缓存完成`,
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              console.log("add kml indexedDb success");
            } else {
              Vue.$NProgress.done(true);
              warningNotify.close();
              Vue.$notify({
                title: `缓存失败`,
                message: "",
                type: "error",
                duration: 960,
                offset: 320,
              });
              console.log("add kml indexedDb fail");
            }
            worker.close();
          });
        })
        .catch((e) => {
          console.error(e);
          worker.close();
        });
    }
  });
}
/**
 * 获取kml数据
 */
function getKmlData(url, id) {
  // 子线程处理函数
  const formatFunc = (data, id) => {
    let textBecomeImg = (
      text,
      fontsize = 20,
      fontcolor = "rgb(156, 205, 156)"
    ) => {
      let canvas = new OffscreenCanvas(1, 1);
      let context = canvas.getContext("2d");
      let firsttxt = text;
      let ratio = 1.5;
      let dataUrl;
      context.font = "bold " + fontsize + "px  Arial";
      canvas.width = (context.measureText(text).width + 10) * ratio;
      canvas.height = (parseInt(fontsize) + 10) * ratio;
      context.translate(canvas.width / 2, canvas.height / 2);
      // 擦除矩形，擦除的意思是把该区域变为透明
      context.clearRect(0, 0, canvas.height, canvas.height);
      context.fillStyle = fontcolor;
      context.font = "bold " + fontsize + "px Arial";
      context.textBaseline = "middle";
      context.textAlign = "center";
      context.scale(ratio, ratio);
      context.strokeStyle = "#000";
      context.strokeText(firsttxt, 0, 0);
      context.fillStyle = fontcolor;
      context.fillText(firsttxt, 0, 0);
      return canvas.convertToBlob();
    };
    let asyncFuns = [],
      kmlObj = [];
    function text(blob) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (e) => {
          resolve(e);
        };
      });
    }
    return new Promise((resolve, reject) => {
      data.forEach((i) => {
        let { POI_ID, name } = i.properties;
        textBecomeImg(name).then((blob) => {
          text(blob).then((e) => {
            kmlObj.push({
              POI_ID: POI_ID,
              image: e.target.result,
            });
            if (kmlObj.length == data.length) {
              resolve({
                res: kmlObj,
              });
            }
          });
        });
      });
    });
  };

  worker = new DataWorker(formatFunc);

  return new Promise((resolve, reject) => {
    kgUtil
      .toGeoJSON(url)
      .then((data) => {
        const result = data.features; //需要处理的数据
        worker
          .send({
            method: "format",
            data: result,
            id: id,
          })
          .then((e) => {
            resolve({
              id: id,
              content: e.res,
            });
          });
      })
      .catch(function (error) {
        Vue.$NProgress.done(true);
        Vue.$notify({
          title: `缓存失败:${error}`,
          message: "",
          type: "error",
          duration: 960,
          offset: 320,
        });
        reject("失败");
      });
  });
}

function getPixelRatio(context) {
  var backingStore =
    context.backingStorePixelRatio ||
    context.webkitBackingStorePixelRatio ||
    context.mozBackingStorePixelRatio ||
    context.msBackingStorePixelRatio ||
    context.oBackingStorePixelRatio ||
    context.backingStorePixelRatio ||
    1;
  return (window.devicePixelRatio || 1) / backingStore;
}
/**
 * 文字转图片
 */
function textBecomeImg(text, fontsize = 20, fontcolor = "#F40E0E") {
  let canvas = new OffscreenCanvas(1, 1);
  let context = canvas.getContext("2d");
  let firsttxt = text;
  let ratio = 1.5;
  let dataUrl;
  context.font = "bold " + fontsize + "px  Arial";
  canvas.width = (context.measureText(text).width + 10) * ratio;
  canvas.height = (parseInt(fontsize) + 10) * ratio;
  context.translate(canvas.width / 2, canvas.height / 2);
  // 擦除矩形，擦除的意思是把该区域变为透明
  context.clearRect(0, 0, canvas.height, canvas.height);
  context.fillStyle = fontcolor;
  context.font = "bold " + fontsize + "px Arial";
  context.textBaseline = "middle";
  context.textAlign = "center";
  context.scale(ratio, ratio);
  context.strokeStyle = "#fff";
  context.strokeText(firsttxt, 0, 0);
  context.fillStyle = fontcolor;
  context.fillText(firsttxt, 0, 0);
  return canvas.convertToBlob();
  // console.log(dataUrl);
  // return dataUrl;
}

/**
 * 透明度数据
 */
export function setUnderground(number, id, fn, ...list) {
  // underground = null;
  let map = Vue.$GLOBAL.map;
  if (list.length > 0) {
    let { mapType } = list[0];
    if (mapType == "clone") {
      map = Vue.$GLOBAL.mapClone;
    }
  }
  if (map) {
    let bimAlpha = map.getThing("bimAlpha");
    if (bimAlpha && bimAlpha.state == "added") {
      bimAlpha.alpha = number;
    } else {
      underground = new mars3d.thing.Underground({
        alpha: number,
        id: "bimAlpha",
      });
      map?.addThing(underground);
    }
  }
}
